import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { Avatar, Link, useMediaQuery } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ScrollToTopButton from 'shared/components/ScrollToTopButton';
import ValuePropositionOne from 'static_pages/caterer/svg/ValuePropositionOne';

function ClaimCatererProfileLargeCTA({
  catererName,
  openClaimCatererProfileForm,
}) {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { t } = useTranslation('caterers');

  return (
    <StyledContainer mobile={mobile}>
      <StyledLeftContainer>
        <StyledTopLeftContainer mobile={mobile}>
          <Avatar />
          <StyledCTATextContainer>
            <StyledCTATitle mobile={mobile}>
              {`${t('caterer.customizeProfileCTAHeader')}${catererName}?`}
            </StyledCTATitle>
            <Typography>{t('caterer.customizeProfileCTALabel')}</Typography>
          </StyledCTATextContainer>
        </StyledTopLeftContainer>
        <StyledBaseLeftContainer>
          <StyledBaseText mobile={mobile}>
            {t('caterer.customizeProfileDescription')}
          </StyledBaseText>
          <StyledBaseText mobile={mobile}>
            <Trans
              t={t}
              i18nKey="caterer.visitPartnerSite"
              components={[<StyledLink href="/caterer" key="link" />]}
            />
          </StyledBaseText>
          <StyledButton onClick={openClaimCatererProfileForm} outlined>
            {t('caterer.customizeProfileButton')}
          </StyledButton>
        </StyledBaseLeftContainer>
      </StyledLeftContainer>
      <StyledRightContainer mobile={mobile}>
        <ValuePropositionOne />
      </StyledRightContainer>
    </StyledContainer>
  );
}

const StyledContainer = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: ${(props) => (props.mobile ? 'column' : 'row')};
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => props.theme.spacing(2)}px;
  margin-top: ${(props) => props.theme.spacing(2)}px;
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
  background: #f8f8f8;
`;

const StyledLeftContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const StyledTopLeftContainer = styled(Box)`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(props.mobile ? 2 : 0)}px;
`;

const StyledCTATextContainer = styled(Box)`
  flex: 1;
  margin-left: ${(props) => props.theme.spacing(2)}px;
`;

const StyledCTATitle = styled(Typography)`
  font-size: ${(props) =>
    props.theme.typography[props.mobile ? 'body1' : 'subtitle1']};
  font-weight: ${(props) =>
    props.theme.typography[props.mobile ? 'h3' : 'subtitle1'].fontWeight};
`;

const StyledBaseLeftContainer = styled(Box)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

const StyledBaseText = styled(Typography)`
  font-size: ${(props) =>
    props.theme.typography[props.mobile ? 'body1' : 'subtitle2'].fontSize};
  margin-top: ${(props) => props.theme.spacing(2)}px;
`;

const StyledRightContainer = styled(Box)`
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
  margin-left: ${(props) => props.theme.spacing(2)}px;
  margin-right: ${(props) => props.theme.spacing(2)}px;
  width: ${(props) => (props.mobile ? 50 : 100)}%;
  height: ${(props) => (props.mobile ? 50 : 100)}%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
  color: #7d8f5b;
`;

const StyledButton = styled(ScrollToTopButton)`
  border-radius: ${(props) => props.theme.spacing(1)}px;
  margin-top: ${(props) => props.theme.spacing(2)}px;
`;

export default ClaimCatererProfileLargeCTA;
